import { z } from 'zod';
export const UserRoleSchema = z.enum(['USER', 'ADMIN', 'CONTROLLER']);
export const UserSchema = z.object({
    id: z.string(),
    phone: z.string(),
    email: z.string().email().optional(),
    role: UserRoleSchema,
    locale: z.string().default('fr-TN'),
    createdAt: z.date(),
    updatedAt: z.date(),
});
export const CreateUserSchema = z.object({
    phone: z.string().regex(/^\+216[0-9]{8}$/, 'Numéro de téléphone tunisien invalide'),
    email: z.string().email().optional(),
    role: UserRoleSchema.default('USER'),
});
